import React, { useState, useEffect, useContext, useRef } from "react";
import { AppContext } from "../AppContextProvider";
import FeedbackComponent from "./FeedbackComponent";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import Captions from "yet-another-react-lightbox/plugins/captions";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Slideshow from "yet-another-react-lightbox/plugins/slideshow";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Share from "yet-another-react-lightbox/plugins/share";
import Download from "yet-another-react-lightbox/plugins/download";
import Video from "yet-another-react-lightbox/plugins/video";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/plugins/captions.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import { Scrollbar } from "react-scrollbars-custom";
import InfoComponent from "./InfoComponent";
import { WarningTicket, InformationsTicket, NotificationsTicket, ErrorTicket } from "./TicketsComponent";

export default function InfoView(props) {
  const context = useContext(AppContext);
  const [isDark, setIsDark] = useState(true);
  const [isVisibilityDiv, setIsVisibilityDiv] = useState(true);
  const [pfadArray, setPfadArray] = useState([]);
  const [open, setOpen] = useState(false);
  const [isHover, setIsHover] = useState(false);
  const [foto, setFoto] = useState([]);
  const [isErrorTicket, setIsErrorTicket] = useState(false);
  const [errortext, setErrortext] = useState(undefined);

  useEffect(() => {
    if (
      document.documentElement.getAttribute("data-color-mode") === "dark" ||
      document.documentElement.getAttribute("data-color-mode") === null
    ) {
      setIsDark(true);
    } else {
      setIsDark(false);
    }
  }, [context.getState()?.isRender]);

  useEffect(() => {
    if (props.nodeDatas?.group && props.nodes && props.network) {
      var parentsPfadArray = [];
      var categoryNumber = props.nodeDatas.group.charAt(0);
      var level = props.nodeDatas.level;
      var id = props.nodeDatas.id;
      if (level > 1) {
        while (level > 1) {
          var actuelleNode = props.nodes.filter((k) => k.id === props.network.getConnectedNodes(id, "from")[0])[0];
          var text = actuelleNode.value2;
          id = actuelleNode.id;
          if (text) {
            let s = text.toString();
            let capitalizedvalue2 = s[0].toUpperCase() + s.slice(1);
            let finishText = capitalizedvalue2.match(/[A-Z][a-z]+|[0-9]+/g)
              ? capitalizedvalue2

                  .match(/[A-Z][a-z]+|[0-9]+/g)
                  .join(" ")
                  .replace("_", " ")
              : s.replace("_", " ");
            parentsPfadArray.push(finishText);
          }
          level = level - 1;
        }
      }
      setPfadArray(parentsPfadArray.reverse());
    }
  }, [props]);

  const setOpenLightbox = (foto) => {
    let array = [];
    array.push(foto);
    setFoto(array);
    setOpen(true);
  };

  const memory = {};
  return (
    <div className="prevent-select">
      <div
        className={
          props.isGraphSite
            ? isVisibilityDiv
              ? !props.navbarShrunk
                ? "node-data-div"
                : "node-data-divscroll"
              : !props.navbarShrunk
                ? "node-data-div hidden"
                : "node-data-div hidden scroll"
            : isVisibilityDiv
              ? !props.navbarShrunk
                ? "node-data-div explorer"
                : "node-data-div explorer scroll"
              : !props.navbarShrunk
                ? "node-data-div explorer hidden"
                : "node-data-div explorer hidden scroll"
        }
      >
        {/*props.isVisibility && (
          <div className="skip-button-div">
            <button
              type="button"
              className="button outline large"
              onClick={() => {
                props.setIsVisibility();
                props.setIsVisibility2();
                localStorage.setItem("isLottieLookingAtIt", "true");
                setTimeout(() => {
                  // context.openModal("centralinfo", "");
                }, 250);
              }}
            >
              <span className="text">Skip</span>
            </button>
          </div>
        )*/}

        {props.isGraphSite ? null : (
          <Scrollbar
            id="scrollbar"
            style={{ width: "100%", height: "calc(100vh - 170px)" }}
            maximalThumbYSize={150}
            noScrollX={true}
          >
            <div className="scroll-div">
              <div className="addfiles-div" style={{ width: "251px" }}>
                <button
                  className="button accent large"
                  style={{ width: "100%", height: "26px" }}
                  onClick={() =>
                    context.openModal("importorupload", "", {
                      processedGraph: props.processedGraph,
                      onFinish: props.refreshGraph,
                      onError: (errorString) => {
                        context.closeModal();
                        setIsErrorTicket(true);
                        setErrortext(errorString);
                      },
                    })
                  }
                >
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M10 17.5C8.51664 17.5 7.0666 17.0601 5.83323 16.236C4.59986 15.4119 3.63856 14.2406 3.07091 12.8701C2.50325 11.4997 2.35472 9.99168 2.64411 8.53683C2.9335 7.08197 3.64781 5.7456 4.6967 4.6967C5.7456 3.64781 7.08197 2.9335 8.53683 2.64411C9.99168 2.35472 11.4997 2.50325 12.8701 3.07091C14.2406 3.63856 15.4119 4.59986 16.236 5.83323C17.0601 7.0666 17.5 8.51664 17.5 10C17.4978 11.9885 16.707 13.8949 15.3009 15.3009C13.8949 16.707 11.9885 17.4978 10 17.5V17.5ZM10 3.75C8.76387 3.75 7.5555 4.11656 6.52769 4.80332C5.49988 5.49008 4.6988 6.46619 4.22576 7.60823C3.75271 8.75027 3.62894 10.0069 3.8701 11.2193C4.11125 12.4317 4.70651 13.5453 5.58059 14.4194C6.45466 15.2935 7.56831 15.8888 8.78069 16.1299C9.99307 16.3711 11.2497 16.2473 12.3918 15.7743C13.5338 15.3012 14.5099 14.5001 15.1967 13.4723C15.8834 12.4445 16.25 11.2361 16.25 10C16.2481 8.343 15.589 6.75442 14.4173 5.58273C13.2456 4.41105 11.657 3.75195 10 3.75V3.75ZM13.75 9.21875H10.7813V6.25C10.7813 6.0428 10.6989 5.84409 10.5524 5.69758C10.4059 5.55106 10.2072 5.46875 10 5.46875C9.7928 5.46875 9.59409 5.55106 9.44758 5.69758C9.30106 5.84409 9.21875 6.0428 9.21875 6.25V9.21875H6.25C6.0428 9.21875 5.84409 9.30106 5.69758 9.44758C5.55106 9.59409 5.46875 9.7928 5.46875 10C5.46875 10.2072 5.55106 10.4059 5.69758 10.5524C5.84409 10.6989 6.0428 10.7813 6.25 10.7813H9.21875V13.75C9.21875 13.9572 9.30106 14.1559 9.44758 14.3024C9.59409 14.4489 9.7928 14.5313 10 14.5313C10.2072 14.5313 10.4059 14.4489 10.5524 14.3024C10.6989 14.1559 10.7813 13.9572 10.7813 13.75V10.7813H13.75C13.9572 10.7813 14.1559 10.6989 14.3024 10.5524C14.4489 10.4059 14.5313 10.2072 14.5313 10C14.5313 9.7928 14.4489 9.59409 14.3024 9.44758C14.1559 9.30106 13.9572 9.21875 13.75 9.21875Z"
                      fill="white"
                    />
                  </svg>
                  <span className="text">Add files</span>
                </button>
              </div>
              <div className="d-none d-lg-block">
                {props.file && props.isNodeSelect && (
                  <div className="folder-info-div">
                    <div className="title-div">
                      <span>{props.fileName}</span>
                    </div>
                    {props.fileType === "image/jpg" ||
                    props.fileType === "image/jpeg" ||
                    props.fileType === "image/png" ||
                    props.fileName.includes("JPG") ? (
                      <div className="img-div">
                        <img
                          src={props.file}
                          alt=""
                          onClick={() => setOpenLightbox(props.file)}
                          style={{ cursor: "pointer" }}
                          onMouseEnter={() => setIsHover(true)}
                          onMouseLeave={() => setIsHover(false)}
                        />
                        {isHover && (
                          <div
                            className="svg-icon"
                            onMouseEnter={() => setIsHover(true)}
                            onClick={() => setOpenLightbox(props.file)}
                          >
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M8.56685 12.3168L4.63361 16.2501H6.8751C7.04773 16.2501 7.20398 16.3201 7.31698 16.4331C7.43 16.5461 7.5001 16.7023 7.5 16.8751C7.5 17.2202 7.22023 17.5 6.8751 17.5H3.12486C3.12411 17.5 3.12348 17.4996 3.12286 17.4996C3.04211 17.4993 2.96186 17.4831 2.88625 17.4517C2.73323 17.3885 2.61148 17.2667 2.54823 17.1137C2.51686 17.038 2.50061 16.9578 2.50036 16.8771C2.50036 16.8765 2.5 16.8758 2.5 16.8751V13.1248C2.5 12.7796 2.77973 12.5 3.12486 12.5C3.47011 12.5 3.74986 12.7796 3.74986 13.1248L3.74973 15.3665L7.6831 11.4331C7.92723 11.189 8.32273 11.189 8.56685 11.4331C8.81098 11.6772 8.81098 12.0727 8.56685 12.3168ZM11.4331 12.3168L15.3663 16.2501H13.1248C12.9522 16.2501 12.796 16.3201 12.683 16.4331C12.57 16.5461 12.4998 16.7023 12.5 16.8751C12.5 17.2202 12.7797 17.5 13.1248 17.5H16.8751C16.8758 17.5 16.8765 17.4996 16.8771 17.4996C16.9578 17.4993 17.0381 17.4831 17.1137 17.4517C17.2667 17.3885 17.3885 17.2667 17.4517 17.1137C17.4831 17.038 17.4993 16.9578 17.4996 16.8771C17.4996 16.8765 17.5 16.8758 17.5 16.8751V13.1248C17.5 12.7796 17.2202 12.5 16.8751 12.5C16.5298 12.5 16.2501 12.7796 16.2501 13.1248L16.2502 15.3665L12.3168 11.4331C12.0727 11.189 11.6772 11.189 11.4331 11.4331C11.189 11.6772 11.189 12.0727 11.4331 12.3168ZM8.56685 7.68312L4.63361 3.74987H6.8751C7.04773 3.74987 7.20398 3.67987 7.31698 3.56687C7.43 3.45387 7.5001 3.29762 7.5 3.12487C7.5 2.77975 7.22023 2.5 6.8751 2.5H3.12486C3.12411 2.5 3.12348 2.50037 3.12286 2.50037C3.04211 2.50062 2.96186 2.51687 2.88625 2.54825C2.73323 2.6115 2.61148 2.73325 2.54823 2.88625C2.51686 2.962 2.50061 3.04213 2.50036 3.12288C2.50036 3.1235 2.5 3.12412 2.5 3.12487V6.87512C2.5 7.22038 2.77973 7.5 3.12486 7.5C3.47011 7.5 3.74986 7.22038 3.74986 6.87512L3.74973 4.6335L7.6831 8.56688C7.92723 8.811 8.32273 8.811 8.56685 8.56688C8.81098 8.32275 8.81098 7.92725 8.56685 7.68312ZM11.4331 8.56688C11.6772 8.811 12.0727 8.811 12.3168 8.56688L16.2502 4.6335L16.2501 6.87512C16.2501 7.22038 16.5298 7.5 16.8751 7.5C17.2202 7.5 17.5 7.22038 17.5 6.87512V3.12487C17.5 3.12412 17.4996 3.1235 17.4996 3.12288C17.4993 3.04213 17.4831 2.962 17.4517 2.88625C17.3885 2.73325 17.2667 2.6115 17.1137 2.54825C17.0381 2.51687 16.9578 2.50062 16.8771 2.50037C16.8765 2.50037 16.8758 2.5 16.8751 2.5H13.1248C12.7797 2.5 12.5 2.77975 12.5 3.12487C12.4998 3.29762 12.57 3.45387 12.683 3.56687C12.796 3.67987 12.9522 3.74987 13.1248 3.74987H15.3663L11.4331 7.68312C11.189 7.92725 11.189 8.32275 11.4331 8.56688Z"
                                fill="white"
                              />
                            </svg>
                          </div>
                        )}
                      </div>
                    ) : (
                      <div className="file-default-icon">
                        {props.fileType === "application/x-zip-compressed" && (
                          <div
                            onClick={() => {
                              if (props.isDownloadButton) {
                                props.downloadZip(props.nodeDatas.properties.fileStorageId);
                              }
                            }}
                          >
                            <svg
                              width="64"
                              height="64"
                              viewBox="0 0 64 64"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M16 24V12H40V20H48V24H52V18.8008C52 18.2695 51.7891 17.7617 51.4141 17.3867L42.6133 8.58594C42.2383 8.21094 41.7305 8 41.1992 8H14C12.8945 8 12 8.89453 12 10V24H16ZM48 48V52H16V48H12V54C12 55.1055 12.8945 56 14 56H50C51.1055 56 52 55.1055 52 54V48H48Z"
                                fill="var(--text-accent-tertiary)"
                              />
                              <path
                                d="M12 44V41.4128L21.0838 29.861V30.9277H12V28H24.5108V30.5872L15.4035 42.1163V41.0723H24.8628V44H12Z"
                                fill="var(--text-accent-tertiary)"
                              />
                              <path d="M29.375 44V28H33.0133V44H29.375Z" fill="var(--text-accent-tertiary)" />
                              <path
                                d="M38.6677 44V28H46.2258C47.462 28 48.5104 28.2043 49.3711 28.6128C50.2318 29.0213 50.8812 29.6038 51.3193 30.3603C51.7731 31.1168 52 32.0322 52 33.1064C52 34.1806 51.7731 35.1035 51.3193 35.8752C50.8812 36.6317 50.2318 37.2142 49.3711 37.6227C48.5104 38.0312 47.462 38.2355 46.2258 38.2355H42.3059V44H38.6677ZM42.3059 35.5121H45.6155C46.5544 35.5121 47.2664 35.3078 47.7515 34.8993C48.2523 34.4908 48.5026 33.8931 48.5026 33.1064C48.5026 32.3196 48.2523 31.7296 47.7515 31.3362C47.2664 30.9428 46.5544 30.7461 45.6155 30.7461H42.3059V35.5121Z"
                                fill="var(--text-accent-tertiary)"
                              />
                            </svg>
                          </div>
                        )}
                        {props.fileType === "application/pdf" && (
                          <svg
                            width="64"
                            height="64"
                            viewBox="0 0 64 64"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M16 24V12H40V20H48V24H52V18.8008C52 18.2695 51.7891 17.7617 51.4141 17.3867L42.6133 8.58594C42.2383 8.21094 41.7305 8 41.1992 8H14C12.8945 8 12 8.89453 12 10V24H16ZM48 48V52H16V48H12V54C12 55.1055 12.8945 56 14 56H50C51.1055 56 52 55.1055 52 54V48H48Z"
                              fill="var(--text-accent-tertiary)"
                            />
                            <path
                              d="M12 44V28H18.7277C19.8281 28 20.7613 28.2043 21.5274 28.6128C22.2935 29.0213 22.8716 29.6038 23.2616 30.3603C23.6655 31.1168 23.8675 32.0322 23.8675 33.1064C23.8675 34.1806 23.6655 35.1035 23.2616 35.8752C22.8716 36.6317 22.2935 37.2142 21.5274 37.6227C20.7613 38.0312 19.8281 38.2355 18.7277 38.2355H15.2385V44H12ZM15.2385 35.5121H18.1845C19.0202 35.5121 19.654 35.3078 20.0858 34.8993C20.5315 34.4908 20.7544 33.8931 20.7544 33.1064C20.7544 32.3196 20.5315 31.7296 20.0858 31.3362C19.654 30.9428 19.0202 30.7461 18.1845 30.7461H15.2385V35.5121Z"
                              fill="var(--text-accent-tertiary)"
                            />
                            <path
                              d="M25.8745 44V28H31.6411C33.3126 28 34.7334 28.3177 35.9034 28.9532C37.0874 29.5735 37.9858 30.4813 38.5987 31.6766C39.2255 32.8567 39.5389 34.2941 39.5389 35.9887C39.5389 37.6832 39.2255 39.1281 38.5987 40.3234C37.9858 41.5187 37.0874 42.434 35.9034 43.0695C34.7334 43.6898 33.3126 44 31.6411 44H25.8745ZM29.113 41.1177H31.4531C33.0271 41.1177 34.2041 40.6941 34.9841 39.8468C35.7641 38.9995 36.1541 37.7135 36.1541 35.9887C36.1541 34.2638 35.7571 32.9853 34.9632 32.1532C34.1832 31.3059 33.0131 30.8823 31.4531 30.8823H29.113V41.1177Z"
                              fill="var(--text-accent-tertiary)"
                            />
                            <path
                              d="M42.0547 44V28H52V30.7461H45.2932V34.6496H51.5403V37.3957H45.2932V44H42.0547Z"
                              fill="var(--text-accent-tertiary)"
                            />
                          </svg>
                        )}
                        {props.fileType !== "application/pdf" && props.fileType !== "application/x-zip-compressed" && (
                          <svg
                            width="64"
                            height="64"
                            viewBox="0 0 64 64"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M51.4141 17.3867L42.6133 8.58592C42.2383 8.21092 41.7305 8 41.1992 8H14C12.8945 8 12 8.89452 12 10V54C12 55.1055 12.8945 56 14 56H50C51.1055 56 52 55.1055 52 54V18.8008C52 18.2696 51.7891 17.7617 51.4141 17.3867ZM16 52V12H40V20H48V52H16Z"
                              fill="var(--text-accent-tertiary)"
                            />
                          </svg>
                        )}
                      </div>
                    )}
                  </div>
                )}
                {props.isNodeSelect && props.nodeDatas && (
                  <div className="folder-info-div">
                    {pfadArray.length > 0 && (
                      <div className="pfad-div">
                        {pfadArray.map((k, n) => {
                          return (
                            <span className="pfad-text" key={n}>
                              {k + "/"}
                            </span>
                          );
                        })}
                      </div>
                    )}
                    <div className="title-div">
                      <span>{props.nodeDatas.label}</span>
                    </div>
                    {props.nodeDatas.properties &&
                      Object.entries(props.nodeDatas.properties).map(([k, n], l) => {
                        return (
                          <div className="div-2" key={l} style={{ cursor: "pointer" }}>
                            {n !== undefined && (
                              <>
                                <span className="description-text">
                                  {k.toString().match(/[A-Z][a-z]+|[0-9]+/g) !== null
                                    ? k
                                        .toString()
                                        .match(/[A-Z][a-z]+|[0-9]+/g)
                                        .join(" ") +
                                      ": " +
                                      n.toString().replace("_", " ")
                                    : k + ": " + n.toString().replace("_", " ")}
                                </span>
                              </>
                            )}
                          </div>
                        );
                      })}
                  </div>
                )}
                {props.nodesCount && (
                  <div className="folder-info-div">
                    <div className="title-div">
                      <span>Overview</span>
                    </div>
                    <div className="div-2">
                      <span className="description-text">
                        {"Displaying " + props.nodesCount + " nodes, " + props.edgesCount + " relationships."}
                      </span>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </Scrollbar>
        )}

        <Lightbox
          open={open}
          close={() => setOpen(false)}
          slides={foto.map((k) => {
            return { src: k };
          })}
          plugins={[Captions, Fullscreen, Video, Zoom, Download, Share]}
          captions={{
            hidden: false,
          }}
          styles={{
            root: { "--yarl__color_backdrop": "rgba(0, 0, 0, .9)" },
            navigationNext: {
              "--yarl__color_button": "transparent",
              "--yarl__color_button_active": "transparent",
              "--yarl__color_button_hover": "transparent",
            },
            navigationPrev: {
              "--yarl__color_button": "transparent",
              "--yarl__color_button_active": "transparent",
              "--yarl__color_button_hover": "transparent",
            },
          }}
        />
      </div>
      {props.isGraphSite && (
        <InfoComponent
          text2={"Tip 2: Right click on a node to open context menu."}
          text1={"Tip 1: Double click on a node to show or hide sub nodes."}
        />
      )}

      <div className="ticket-div">
        {isErrorTicket && (
          <>
            <ErrorTicket
              close={() => {
                setIsErrorTicket(false);
                props.refreshGraph();
              }}
              text={errortext}
            />
            <div style={{ height: "20px" }} />
          </>
        )}
      </div>
    </div>
  );
}
